





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button } from 'element-ui';
import Banner from '@/components/layout/banners/Banner.vue';

@Component({
  components: {
    Banner,
    'el-button': Button
  }
})
export default class NewContent extends Vue {
  isClose = false;

  refresh() {
    window.location.reload();
  }

  /**
   * @description return a random index to display a random message
   */
  randomMessage() {
    return Math.floor(Math.random() * Math.floor(this.$t('banner.new-content.text').length as number));
  }
}
